<template>
    <div class="product-list-panel">
        <out-of-stock-brief v-if="noItems" :brief="brief" />
        <g-row v-else type="flex" justify="start" align="middle" :gutter="[8, 8]">
            <g-column v-for="(product, productIdx) in products" :key="product.id + productIdx" :span="12">
                <product-panel-item
                    :key="product.id + '.' + productIdx"
                    class="product-list-panel-item"
                    :brief="brief"
                    :product="product"
                    @click.native="handleProductSelect(product, productIdx)"
                />
            </g-column>
        </g-row>

        <slot name="footer" />
    </div>
</template>

<script>
    import ProductPanelItem from './ProductPanelItem.vue';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import OutOfStockBrief from './OutOfStockBrief';
    export default {
        name: 'PanelProductItems',
        components: {
            ProductPanelItem,
            OutOfStockBrief
        },
        mixins: [ActivationBriefProductConfigMixin],
        props: {
            products: {
                type: Array,
                required: true
            }
        },
        computed: {
            noItems() {
                return this.products.length === 0;
            }
        },
        methods: {
            handleProductSelect(product, productIdx) {
                if (product.is_in_stock) {
                    this.$emit('selected', product, productIdx);
                }
            }
        }
    };
</script>

<style lang="scss" scoped></style>
